module.exports = __webpack_public_path__ + "static/images/containers/CommandCenterCard/images/ribbon.675a6521.png";


//////////////////
// WEBPACK FOOTER
// ./containers/CommandCenterCard/images/ribbon.png
// module id = 3085
// module chunks = 11